export default __webpack_public_path__ + "static/media/CNo.91-1.90fedd00.jpg";